
<template>
  <div class="addFishSales">
    <div class="add-content-container">
      <div class="add-titieMain">
        <div class="add-title-container">成鱼销售单</div>
        <div class="add-content">
          <div class="operation-btn">
            <el-button size="small" class="del" @click="onDelete" :disabled="enableTable||!edit">删除</el-button>
            <el-button size="small" class="add" @click="onAdd" :disabled="enableTable||!edit">增加</el-button>
            <el-button size="small" class="alter" @click="onAlter" :disabled="enableTable||!edit">修改</el-button>
            <el-button size="small" class="save" v-throttle-button="onSave" :disabled="!enableTable||!edit">保存</el-button>
            <el-button size="small" class="cancel" @click="onRollBack" :disabled="!enableTable||!edit">撤销</el-button>
            <el-button size="small" class="close" @click="closeView">关闭</el-button>
          </div>
          <div class="custom-search-container" style="margin-top:15px;">
            <div class="custom-search-box">
              <div class="custom-search-box-warpper" >
                <span>基地</span>
                <el-select v-model="order.fishBaseId" filterable placeholder="请选择" size="small" @change="baseChange"  :disabled="Boolean(orderId) ||!edit">
                  <el-option v-for="(item, index) in baseLists" :key="index" :label="item.value" :value="item.key">
                  </el-option>
                </el-select>
              </div>
             
              <div class="custom-search-box-warpper">
                <span>客户</span>
                <el-select v-model="order.provider" filterable placeholder="请选择" size="small" @change="providerChange" :disabled="!edit">
                  <el-option v-for="(item, index) in providerList" :key="index" :label="item.value" :value="item.key">
                  </el-option>
                </el-select>
              </div>
              <!-- <div class="custom-search-box-warpper">
                <span>流水号</span>
                <el-input placeholder="请输入流水号" v-model="order.numericalOrder" size="small" disabled>
                </el-input>
              </div> -->
              <div class="custom-search-box-warpper">
                <span>车牌号</span>
                <el-input placeholder="请输入车牌号" v-model="order.carNumber" size="small">
                </el-input>
              </div>
            </div>
            <div class="custom-search-box">
              <div class="custom-search-box-warpper">
                <span>塘口</span>
                <el-select v-model="order.pond" filterable placeholder="请选择" size="small" @change="topPondChange" :disabled="Boolean(orderId) ||!edit">
                  <el-option v-for="(item, index) in topPondList" :key="index" :label="item.value" :value="item.key">
                  </el-option>
                </el-select>
                <span v-if="order.pond != ''">&nbsp;&nbsp;&nbsp;周期：{{this.order.fishBatch}}</span>
              </div>
              <div class="custom-search-box-warpper" v-if="order.pond != ''" style="margin-left:-95px;">
                <span>日期</span>
                <el-date-picker size="small" v-model="order.date" :disabled="!edit" type="date" placeholder="请选择日期" value-format="yyyy-MM-dd" :picker-options="pickerTimeOptions">
                </el-date-picker>
              </div>
              <div class="custom-search-box-warpper" v-else >
                <span>日期</span>
                <el-date-picker size="small" v-model="order.date" :disabled="!edit" type="date" placeholder="请选择日期" value-format="yyyy-MM-dd" :picker-options="pickerTimeOptions">
                </el-date-picker>
              </div>
              <div class="custom-search-box-warpper">
                <span>单据号</span>
                <el-input placeholder="请输入单据号" v-model="order.billsNo" size="small" disabled>
                </el-input>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="table-container">
        <table-ex :showIndex='true' :enable="enableTable&&edit">
          <thead-ex>
            <th-ex v-if="order.pond == ''">塘口</th-ex>
            <th-ex v-if="order.pond == ''">周期</th-ex>
            <th-ex  class="long-td">品种</th-ex>
            <th-ex>规格单位</th-ex>
            <th-ex tip="规格单位为斤/尾时，请填写均重；当单位为尾/斤和万尾时，请填写规格">均重(规格)</th-ex>
            <th-ex>重量(斤)</th-ex>
            <th-ex>数量</th-ex>
            <th-ex tip="当重量为0，单价以数量为计价单价； 当重量不为0，单价为以重量计价单价" class="long-td">单价</th-ex>
            <th-ex tip="金额默认=重量*单价；当重量为0，则金额=数量*单价" class="long-td">金额(元)</th-ex>
            <th-ex tip="用于填写折扣金额，-负数代表减少结算金额，+代表增加结算金额" class="long-td">调整金额(元)</th-ex>
            <th-ex>结算金额(元)</th-ex>
            <th-ex>单据编号</th-ex>
            <th-ex>备注</th-ex>
          </thead-ex>
          <tbody-ex>
            <tr-ex v-for="(item,index) in order.details" :key="index" @selected="selectedRow=item">
              <td-ex v-if="order.pond == ''" v-model="item.pond" :editable="item.pondEdit" :list="fishPondList" display="value" take="key" type='cmb' @selected="pondChange(item)"></td-ex>
              <td-ex v-if="order.pond == ''" v-model="item.fishBatch" :editable="item.pondEdit" type='text'></td-ex>
              <td-ex v-if="order.pond == ''" v-model="item.fishId" :editable="item.fishEdit" type='cmb' :list="item.fishList" display="name" take="id" @selected="fishChange(item)"></td-ex>
              <td-ex v-if="order.pond != ''" v-model="item.fishId" :editable="item.fishEdit" type='cmb' :list="fishList" display="name" take="id" @selected="fishChange(item)"></td-ex>
              <td-ex v-model="item.specType"  class="long-td" type='cmb' :list="measurementList" display="name" take="id"  @selected="measureChange(item,index)"></td-ex>
              <!-- <td-ex v-model="item.unit" type='input'   onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" ></td-ex> -->
              <td-ex v-model="item.avgWeight" type='number'  number @input="setQuantityAmount(item)" positive :decimalLength="4"></td-ex>
              <td-ex v-model="item.weight" type='number'  number @input="setMoneyAmount(item)|| setQuantityAmount(item)||setAvgWeightAmount(item)" positive :decimalLength="2"></td-ex>
              <td-ex v-model="item.quantity" type='number' number @input="setMoneyAmount(item)||setAvgWeightAmount(item)" positive></td-ex>
              <td-ex v-model="item.unitPriceTax" type='number' number @input="setMoneyAmount(item)" positive :decimalLength="2"></td-ex>
              <td-ex v-model="item.amountTotal"  type='text' @input="setFinalAmount(item)" number></td-ex>
              <td-ex v-model="item.amountAdjust"  type='number' @input="setFinalAmount(item)" number :decimalLength="2"></td-ex>
              <td-ex v-model="item.finalAmount"  type='text' number></td-ex>
              <td-ex v-model="item.number"  type='input' ></td-ex>
              <td-ex v-model="item.detailRemark"  type='input' ></td-ex>
            </tr-ex>
          </tbody-ex>
          <tfoot-ex v-model="order.remark" :small-change-amount.sync="order.smallChangeAmount" @addRow="addRow" @delRow="delRow">
            <td>合计</td>
            <td v-if="order.pond == ''">--</td>
            <td v-if="order.pond == ''">--</td>
            <td>--</td>
            <td>--</td>
            <td>--</td>
            <td>{{total('weight')}}</td>
            <td>{{total('quantity')}}</td>
            <td>--</td>
            <td>{{total('amountTotal')}}</td>
            <td>{{total('amountAdjust')}}</td>
            <td>{{total('finalAmount')}}</td>
            <td>--</td>
            <td>--</td>
          </tfoot-ex>
        </table-ex>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { modules } from "../../../store";
import { MessageBox, Message } from "element-ui";
import { storage } from "../../../service/storage";
import checkPermission from "../../../service/checkPermission.js";
import mixins from "@/common/MixIn.js";
export default {
  name: "addFishSales",
  mixins: [mixins],
  data() {
    return {
            // 限制日期
      pickerTimeOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        }
      },
      orderId: this.$route.query.id,
      order: {
        fishBaseId: null,
        provider: null,
        providerName: "",
        pond: "",
        fishBatch: "",
        fishBatchId: "",
        date: new Date(),
        numericalOrder: 0,
        billsNo: 0,
        remark: "",
        smallChangeAmount: 0,
        details: [],
        carNumber: ''
      },
      baseLists: [],
      providerList: [],
      fishList: [],
      measurementList: [],
      enableTable: false,
      selectedRow: null,
      emptyRow: {
        pond: null,
        fishBatch: null,
        fishBatchId: null,
        fishId: null,
        fishName: "",
        unit: "",
        weight: 0,
        avgWeight: 0,
        quantity: 0,
        unitPriceTax: 0,
        amountTotal: 0,
        amountAdjust: 0,
        finalAmount: 0,
        fishList: [],
        genre: "text",
        algorithm: "",
        specType: "",
        detailRemark: "",
        number: ""
      },
      fishPondList: [],
      topPondList: []
    };
  },
  async mounted() {
    await this.initPagePermission();
    if (this.$route.query.id) {
      document.title = this.edit ? "编辑成鱼销售" : "查看成鱼销售";
    } else {
      document.title = "增加成鱼销售";
    }

    //经销商
    let fishProvide = storage.get("fishProvide");
    this.providerList = await this.getCustomList();
    this.order.provider = this.providerList[0].key // 增加默认选择
    this.measurementList = await this.getCultureBreed(); //计量单位
    let oldProvider = this.providerList.find(f => f.key == fishProvide);
    if (!this.$route.query.id && oldProvider) {
      this.order.provider = oldProvider.key;
      await this.providerChange(this.order.provider);
      storage.set("fishProvide", this.order.provider);
    } else if (this.providerList.length > 0) {
      await this.providerChange(this.order.provider);
    }

    //基地
    let purchaseBase = storage.get("base");
    this.baseLists = await this.getBaseList(); //供应商
    let oldBase = this.baseLists.find(f => f.key == purchaseBase);
    if (!this.$route.query.id && oldBase) {
      this.order.fishBaseId = oldBase.key;
      await this.baseChange(this.order.fishBaseId);
      // storage.set("base", this.order.fishBaseId);
    } else if (this.baseLists.length > 0) {
      this.order.fishBaseId = this.baseLists[0].key;
      await this.baseChange(this.order.fishBaseId);
    }
    this.initData();
  },
  methods: {
    ...mapActions(modules.fishSales, {
      getPondUnclearedBatchNo: "getPondUnclearedBatchNo", //周期批次
      addFishSales: "addFishSales", //添加
      updateFishSales: "updateFishSales", //修改
      getfishSalesData: "getfishSalesData", //查询所有数据
      getFishSalesData: "getFishSalesData", //编辑--获取行数据
      delFishSalesList: "delFishSalesList" //删除
    }),
    ...mapActions(modules.cultureCycle, {
      addFishBatch: "addFishBatch"
    }),
    ...mapActions(modules.base, {
      getBaseList: "getBaseList" //基地
    }),
    ...mapActions(modules.pond, {
      getFishPond: "getFishPond" //塘口
    }),
    ...mapActions(modules.fish, {
      getPondFishList: "getPondFishList" //塘口下的渔种
    }),
    ...mapActions(modules.customer, {
      getCustomList: "getCustomList" //获取经销商列表
    }),
    ...mapActions({
      getSerialNumber: "getSerialNumber"
    }),
    ...mapActions(modules.dataDict, [
      "getCultureBreed" //获取养殖品种
    ]),
    ...mapActions(['delVisitedViews']),
    //总计
    total(prop) {
      let total = 0;
      this.order.details.forEach(item => (total += Number(item[prop])));
      return total.toFixed(2);
    },
    //初始化表格
    initTable() {
      this.order.details = [];
      this.$nextTick(() => this.addRow());
    },
    // getTopPondList
    async getTopPondList(id) {
      this.topPondList = await this.getFishPond(id);
      this.topPondList.unshift({
        key: "",
        value: "全部"
      });
    },
    //初始化数据
    async initData() {
      if (!this.orderId) {
        this.order.numericalOrder = await this.getSerialNumber();
        this.getTopPondList(this.order.fishBaseId);
        this.initTable();
      } else {
        //修改
        let result = await this.getFishSalesData(this.orderId);
        this.order.smallChangeAmount = result.smallChangeAmount;
        this.order.fishBaseId = result.fishBaseId;
        await this.baseChange(result.fishBaseId, true);
        let promises = result.details.map(item =>
          (async () => {
            item.pondEdit = false;
            item.fishEdit = false;
            if (result.fishPondId == null) {
              item.fishList = await this.getPondFishList(item.fishBatchId);
            } else {
              this.fishList = await this.getPondFishList(item.fishBatchId);
            }
            // item.fishId = item.fishId;
            // item.fishName = item.fishName;
            // 加载时不要重算金额，沿用接口返回的金额，只补结算金额
            this.setMoneyAmount(item, true);
            this.setFinalAmount(item);
            this.setQuantityAmount(item);
            this.setAvgWeightAmount(item);
          })()
        );
        await Promise.all(promises);
        this.order = result;
        // this.$set(this.order, "details", result.details);
        this.orderId = result.id;
        this.getTopPondList(result.fishBaseId);
        this.topPondList = await this.getFishPond(result.fishBaseId);
        if (result.fishPondId === null) {
          this.order.pond = "";
        } else {
          this.order.pond = result.fishPondId;
          this.order.fishBatch = result.details[0].fishBatch;
          this.order.fishBatchId = result.details[0].fishBatchId;
        }
      }
      this.enableTable = true;
    },
    //改变基地数据
    async baseChange(e, notShowTip) {
      storage.set("base", e);
      if (!notShowTip && !this.baseLists.find(f => f.key == e).notCleard) {
        this.$Alert.info({
          content: "当前选择的基地已经全部清塘，请选择其他基地",
          duration: 5000,
          status: "error"
        });
      }

      await this.getFishPond(e)
        .then(data => {
          this.fishPondList = data;
          if (this.fishPondList.length === 0) {
            this.$Alert.info({
              content: "当前选择的基地下无塘口，请先添加塘口信息",
              duration: 5000,
              status: "error"
            });
          }
        })
        .catch(() => {});

      this.order.details.forEach(f => {
        f.pond = null;
        f.fishBatchId = null;
        f.fishBatch = null;
      });
      if (!this.orderId) {
        this.topPondList = await this.getFishPond(e);
        this.topPondList.unshift({
          key: "",
          value: "全部"
        });

        this.order.pond = "";
      }
    },
    //供应商数据
    providerChange(id) {
      storage.set("fishProvide", id);
      let item = this.providerList.find(f => f.key == id);
      if (item) this.order.providerName = item.value;
    },
    async topPondChange(e) {
      if (!e) {
        //当什么都没有选中，则清理
        this.order.fishBatchId = "";
        this.order.fishBatch = null;
        return;
      }

      let result = await this.getPondUnclearedBatchNo(e);
      if (result) {
        this.order.fishBatchId = result.key;
        this.order.fishBatch = result.value;
        this.order.details.forEach(async (f, index) => {
          console.log(2, f);
          f.fishId = null;
          f.fishName = "";
          f.specType = null;
          let a = await this.getPondFishList(result.key);

          this.fishList = a;
          if (this.fishList.length == 0) {
            this.$Alert.info({
              content: "此塘口当前周期无进苗数据",
              duration: 5000,
              status: "error"
            });
          }
        });
        // this.order.details[0].fishList = await this.getPondFishList(result.key);
        // if (this.order.details[0].fishList.length == 0) {
        //   this.$Alert.info({
        //     content: "此塘口当前周期无进苗数据",
        //     duration: 5000,
        //     status: "error"
        //   });
        // }
        // Message.error("此塘口当前周期无进苗数据");
      } else {
        try {
          await MessageBox.confirm("此塘口已清塘，无法选择周期", "提示", {
            showConfirmButton: false,
            showCancelButton: false
          });
          this.order.fishBatchId = "";
          this.order.fishBatch = "";
        } catch (error) {
          this.order.pond = "";
        }
      }
    },
    //改变塘口--联动周期和渔种
    async pondChange(row) {
      if (!row.pond) {
        //当什么都没有选中，则清理
        row.fishBatchId = null;
        row.fishBatch = null;
        return;
      }

      let result = await this.getPondUnclearedBatchNo(row.pond);
      if (result) {
        row.fishBatchId = result.key;
        row.fishBatch = result.value;
        row.fishId = null;
        row.unit = null;
        row.fishName = null;
        row.fishList = await this.getPondFishList(result.key);
        if (row.fishList.length == 0) {
          this.$Alert.info({
            content: "此塘口当前周期无进苗数据",
            duration: 5000,
            status: "error"
          });
        }
        // Message.error("此塘口当前周期无进苗数据");
      } else {
        try {
          await MessageBox.confirm("此塘口已清塘，无法选择周期", "提示", {
            showConfirmButton: false,
            showCancelButton: false
          });
          row.fishBatchId = null;
          row.fishBatch = null;
        } catch (error) {
          row.pond = null;
        }
      }
    },
    async fishChange(row) {
      // let item = row.fishList.find(f => f.id == row.fishId);
      // if (item) {
      //   row.fishName = item.name;
      //   row.unit = item.unitName;
      //   row.fishCategoryId = item.categoryId;
      // }
      if (this.order.pond) {
        let item = this.fishList.find(f => f.id == row.fishId);
        if (item) {
          row.fishName = item.name;
          row.unit = item.unitName;
          row.fishCategoryId = item.categoryId;
        }
      } else {
        let item = row.fishList.find(f => f.id == row.fishId);
        if (item) {
          row.fishName = item.name;
          row.unit = item.unitName;
          row.fishCategoryId = item.categoryId;
        }
      }
    },
    measureChange(e, index) {
      if (e.specType == 14000) {
        e.weight = 0;
        e.avgWeight = 0;
        e.quantity = 0;
        e.unitPriceTax = 0;
        e.amountTotal = 0;
        e.amountAdjust = 0;
        e.finalAmount = 0;
        this.order.details[index].genre = "text";
        this.order.details[index].algorithm = "1";
      } else if (e.specType == 14001) {
        e.weight = 0;
        e.avgWeight = 0;
        e.quantity = 0;
        e.unitPriceTax = 0;
        e.amountTotal = 0;
        e.amountAdjust = 0;
        e.finalAmount = 0;
        this.order.details[index].genre = "text";
        this.order.details[index].algorithm = "2";
      } else if (e.specType == 14002) {
        e.weight = 0;
        e.avgWeight = 0;
        e.quantity = 0;
        e.unitPriceTax = 0;
        e.amountTotal = 0;
        e.amountAdjust = 0;
        e.finalAmount = 0;
        this.order.details[index].genre = "input";
        this.order.details[index].algorithm = "3";
        console.log(this.order.details);
      } else if (e.specType == 14003) {
        e.weight = 0;
        e.avgWeight = 0;
        e.quantity = 0;
        e.unitPriceTax = 0;
        e.amountTotal = 0;
        e.amountAdjust = 0;
        e.finalAmount = 0;
        this.order.details[index].genre = "input";
        this.order.details[index].algorithm = "4";
        console.log(this.order.details);
      }
    },
    //保存
    async onSave() {
      let err = null;
      if (!this.order.fishBaseId) err = "基地必须选择";
      // if (!this.order.provider) err = "经销商必须选择";
      if (!this.order.date) err = "日期必须选择";
      // let list = this.order.details.filter(
      //   f => JSON.stringify(f) != JSON.stringify(this.emptyRow)
      // );
      let list = [];
      if (this.order.pond == "") {
        list = this.order.details.filter(f => {
          return f.pond !== "" && f.pond !== null;
        });
      } else {
        list = this.order.details.filter(f => {
          return f.fishId !== "" && f.fishId !== null;
        });
        list.map(item => {
          item.pond = this.order.pond;
          item.fishBatch = this.order.fishBatch;
          item.fishBatchId = this.order.fishBatchId;
        });
      }
      let weightReg = /^[0-9]{1,12}([.][0-9]{1,2})?$/; //重量
      let avgWeightReg = /^[0-9]{1,6}([.][0-9]{1,4})?$/; //均重
      // let quantityReg = /^[0-9]{1,12}$/; //数量
      let unitPriceTaxReg = /^[0-9]{1,12}([.][0-9]{1,2})?$/; //单价
      let amountAdjustReg = /^-?[0-9]{1,12}([.][0-9]{1,2})?$/; //调整金额
      if (list.length == 0) err = "不能提交空表单";
      list.forEach(item => {
        console.log(999, item);

        if (item.unitPriceTax === 0) {
          err = "请输入单价";
        }
        if (item.quantity === 0) {
          err = "请输入数量";
        }
        if (!weightReg.test(item.weight)) {
          err = "重量范围至多12位正整数,2位小数";
        }
        if (!avgWeightReg.test(item.avgWeight)) {
          err = "均重范围位0~999999.0000";
        }
        if (!unitPriceTaxReg.test(item.unitPriceTax)) {
          err = "单价范围至多12位正整数,2位小数";
        }
        // if (!quantityReg.test(item.quantity)) {
        //   err = "数量只允许输入整数";
        // }
        if (!amountAdjustReg.test(item.amountAdjust)) {
          err = "调整金额范围至多12位整数,2位小数";
        }
        if (!item.pond) err = "塘口必须选择";
        if (!item.fishBatch || !item.fishBatchId) err = "周期必须选择";
        if (!item.fishId || !item.fishName) err = "品种必须选择";
      });

      if (err) {
        // this.$Alert.info({
        //   content: err,
        //   duration: 1000,
        //   status: "error"
        // });
        Message.error(err);
        return;
      }

      if (list.length > 0) this.order.details = list;
      this.$nextTick(async () => {
        try {
          if (this.orderId) {
            await this.updateFishSales({
              id: this.orderId,
              data: this.filterOrder(this.order)
            });
            this.$message({
              message: "保存成功",
              type: "success"
            });
          } else {
            let result = await this.addFishSales(this.filterOrder(this.order));
            this.orderId = result.id;
            this.order.billsNo = result.number;
            this.order.numericalOrder = result.numericalOrder;
            this.$message({
              message: "保存成功",
              type: "success"
            });
          }
          this.enableTable = false;
        } catch (error) {
          this.$Alert.info({
            content: error.response.data,
            duration: 5000,
            status: "error"
          });
          // Message.error(error.response.data);
        }
      });
    },
    // 当单位为万尾时，转换乘以10000
    filterOrder(arr) {
      let datalist = JSON.parse(JSON.stringify(arr));
      let detail = datalist.details.map(item => {
        if (item.specType == 14002) {
          item.quantity = item.quantity * 10000;
        }
        return item;
      });
      console.log(detail);
      datalist.details = detail;
      return datalist;
    },
    onAlter() {
      this.enableTable = true;
      this.edit = true;
      if (this.orderId) {
        this.order.details.forEach(item => {
          item.pondEdit = false;
          item.fishEdit = false;
        });
      }
    },
    onAdd() {
      this.order.billsNo = 0;
      this.orderId = null;
      this.enableTable = true;
      this.$nextTick(() => this.initData());
    },
    async onDelete() {
      if (!this.orderId) {
        await this.$Alert.info({
          content: "未找到订单Id，无法删除",
          duration: 5000,
          status: "error"
        });
        // Message.error("未找到订单Id，无法删除");
        return;
      }
      try {
        await MessageBox.confirm("是否删除此订单？", "提示");
        try {
          await this.delFishSalesList(this.orderId);
          this.$message({
            message: "删除成功",
            type: "success"
          });
          this.orderId = null;
          this.enableTable = true;
          this.$nextTick(() => this.initTable());
        } catch (error) {
          this.$Alert.info({
            content: error.response.data,
            duration: 5000,
            status: "error"
          });
          // this.$message.error(error.response.data);
        }
      } catch (error) {
        console.log("取消删除");
      }
    },
    onRollBack() {
      this.initData();
      this.edit = false
      this.enableTable = false
    },
    addRow() {
      let list = [];
      for (let i = 0; i < 5; i++) {
        list.push(JSON.parse(JSON.stringify(this.emptyRow)));
      }
      this.order.details = this.order.details.concat(list);
    },
    delRow() {
      this.order.details = this.order.details.filter(
        f => f != this.selectedRow
      );
    },
    // 结算金额 = 金额 + 调整金额
    setFinalAmount(item) {
      let amountTotal = Number(item.amountTotal) || 0;
      let amountAdjust = Number(item.amountAdjust) || 0;
      this.$set(
        item,
        "finalAmount",
        Number((amountTotal + amountAdjust).toFixed(2))
      );
    },
    // 金额 = 重量 × 单价（重量为0时 = 数量 × 单价）；结算金额 = 金额 + 调整金额
    // isInitData = true 时只算结算金额，不覆盖接口返回的金额
    setMoneyAmount(item, isInitData) {
      if (isInitData !== true) {
        let weight = Number(item.weight) || 0;
        let count = weight !== 0 ? weight : Number(item.quantity) || 0;
        let unitPriceTax = Number(item.unitPriceTax) || 0;
        this.$set(
          item,
          "amountTotal",
          Number((count * unitPriceTax).toFixed(2))
        );
      }
      this.setFinalAmount(item);
    },
    setQuantityAmount(item) {
      if (item.specType == 14000) {
        item.algorithm = "1";
      }
      if (item.specType == 14001) {
        item.algorithm = "2";
      }
      if (item.specType == 14002) {
        item.algorithm = "3";
      }
      if (item.specType == 14003) {
        item.algorithm = "4";
      }
      if (item.avgWeight !== 0) {
        switch (item.algorithm) {
          case "1":
            item.quantity = Math.ceil(
              Number(item.weight) / Number(item.avgWeight)
            );
            break;
          case "2":
            item.quantity = Math.ceil(
              Number(item.weight) * Number(item.avgWeight)
            );
            break;
          case "3":
            item.quantity = item.quantity;
            break;
          case "4":
            item.quantity = item.quantity;
            break;
        }
        return true
      }
      console.log(item.quantity);
    },
    setAvgWeightAmount(item) {
      if (item.quantity !== 0) {
        item.avgWeight = Number(
          (Number(item.weight) / Number(item.quantity)).toFixed(2)
        );
      }
      console.log(1);
    },
    closeView(){
      this.delVisitedViews([{
        meta: { affix: false },
        path: this.$route.path,
        title: this.$route.meta.title,
      }])
      this.$router.replace('/buyingAndSelling/fishSales')
    }
  }
};
</script>
<style  >
.danger-color {
  color: #fff;
  border-color: #dd4b39;
  background-color: #dd4b39;
}

.readonlys input {
  pointer-events: none;
  background: #f5f7fa;
}
</style>
